import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListGeofencesResponseFilterSensitiveLog, } from "../models/models_0";
import { de_ListGeofencesCommand, se_ListGeofencesCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class ListGeofencesCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("LocationService", "ListGeofences", {})
    .n("LocationClient", "ListGeofencesCommand")
    .f(void 0, ListGeofencesResponseFilterSensitiveLog)
    .ser(se_ListGeofencesCommand)
    .de(de_ListGeofencesCommand)
    .build() {
}
